import { FormControl, FormField, FormItem, FormLabel } from "@/src/components/ui/form";
import { FiltersFormT } from "./filters.schema";
import { Checkbox } from "../../../components/ui/checkbox";

export const TYPES = [
  {
    id: "automated",
    label: "Automated",
  },
  {
    id: "manual",
    label: "Manual",
  },
];

export const Type = () => {
  return (
    <div>
      <h3 className="text-lg font-semibold col-span-full mb-4">Type</h3>
      <FormField<FiltersFormT, "type">
        name="type"
        render={() => (
          <FormItem>
            {TYPES.map((item) => (
              <FormField
                key={item.id}
                name="type"
                render={({ field }) => {
                  return (
                    <FormItem key={item.id} className="flex flex-row items-start space-x-3 space-y-0">
                      <FormControl>
                        <Checkbox
                          className="w-6 h-6"
                          checked={field.value?.includes(item.id)}
                          onCheckedChange={(checked) => {
                            return checked
                              ? field.onChange([...field.value, item.id])
                              : field.onChange(field.value?.filter((value: string) => value !== item.id));
                          }}
                        />
                      </FormControl>
                      <FormLabel className="font-normal text-base leading-6">{item.label}</FormLabel>
                    </FormItem>
                  );
                }}
              />
            ))}
          </FormItem>
        )}
      />
    </div>
  );
};
